// extracted by mini-css-extract-plugin
module.exports = {"container":"GroupFooter_container__20B5A"};